module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/cd_dvd/icon_5004263ee3ff307f5c02828f80c5231a.png";